module.exports = __webpack_public_path__ + "media/images/bannerImage6-5239f131da0fb427c7ee0acb197bb0d8.jpg";